<script setup>
  import { useWebStore } from '@/store/web.js'
  import { useRoute } from 'vue-router';
  import CTAButton from "~/components/CTA-Button.vue";
  const store = useWebStore();
  const route = useRoute();
  const mainContent = ref(null);
  const chosenTab = computed(() => store.chosenTab);
  const chosenLang = computed(() => store.chosenLang);

  // True on the impresszum / legal-notice page. Compared case-insensitively (the localized
  // `im1` slug like "Impresszum"/"Legal-notice" differs in case from the lowercase route)
  // and trailing-slash-insensitive (no trailingSlash redirect is configured, so both
  // "/hu/impresszum" and "/hu/impresszum/" resolve to the page).
  const isLegalPage = computed(() => {
    const norm = (p) => p.toLowerCase().replace(/\/+$/, '');
    return norm(route.path) === norm(`/${store.chosenLang}/${store.getLocaleString('im1')}`);
  });

  watch([chosenTab,chosenLang], ([newVal1, newVal2]) => {
    useHeaderSet();
  });

    //SETTING LANGUAGE
  if(route.path.split('/')[1]){
    store.chosenLang = route.path.split('/')[1]
  }
  else{
    store.chosenLang = 'hu';
  }
  store.setLanguage(store.chosenLang)


  const handleScroll = ()=> {
      //console.log('Scrolled!', mainContent.value.scrollTop);
      store.navbarHeight=mainContent.value.scrollTop > 800?'3em':'4em'
  }

  //SET DEFAULT HEADERS

  useHead({
        title: 'Poliol Kft.',
        meta: [
          {
            name: 'Poliol Kft.',
            content: 'Poliol Kft.',
          },
        ],
    });

  onMounted(() => {
    // Ensure the ref is available
    if (mainContent.value) {
      mainContent.value.addEventListener('scroll', handleScroll);
    }
    useHeaderSet();

  });

onBeforeUnmount(() => {
    // Clean up the event listener when the component is destroyed
    if (mainContent.value) {
      mainContent.value.removeEventListener('scroll', handleScroll);
    }
  });

  // Watch the route for changes and scroll to top
  watch(route, () => {
    mainContent.value.scrollTop = 0;
  });


</script>
<template>
    <div :style="store.sharedStyle" class="layout">
      <NavBar class="nav" :height="store.navbarHeight"/>
      <NuxtLink
        v-if="!isLegalPage"
        :to="`/${store.chosenLang}/${store.sites[8].url}`"
        class="szechenyi-logo absolute bottom-0 z-40 right-0 h-48 w-48"
      >
        <img class="h-full w-full" src="/szechenyi_plus_eu.webp" alt="Széchenyi Terv Plusz">
      </NuxtLink>

      <div class="main" :style="{marginTop:store.navbarHeight}" ref="mainContent">
        <CTAButton v-if="!store.navOpen
        &&!store.languageBarOpen
        && !store.gdprVisible
        && !isLegalPage"></CTAButton>
        <slot/>
      </div>
      
    </div>
</template>
<style lang="scss">
  .layout {
    display: flex;
    flex-direction: column;
    height: 100dvh; /* 100% of the dynamic viewport height */
    width: 100dvw;
    margin: 0;
  }
  // A logókép bal felső része átlátszó; a vágás a látható rész burkolójára szűkíti a
  // kattintható területet, hogy az átlátszó sarok ne nyelje el az alatta lévő kattintásokat.
  .szechenyi-logo{
    clip-path: polygon(0% 65.6%, 1.6% 50.6%, 7.4% 36.6%, 16.3% 23.5%, 26.5% 13.7%, 35.8% 7.5%, 50.4% 1.3%, 63.5% 0%, 79.8% 0%, 95.1% 3%, 100% 5.3%, 100% 100%, 0% 100%);
  }
  .nav{
    flex: 0 1 auto; /* Adjust the navbar height as needed */
    background-color: #333;
  }
  .main{
    margin-top: 8dvh;
    font-family: Inter,sans-serif;
    height: 100dvh;
    width: 100dvw;
    text-align: center;
    color: var(--dark-font-color);
    overflow: scroll;
    overflow-x: hidden;
    flex: 1 1 auto;
  }

</style>